import { z } from 'zod';

export const adObjectActiveStatusSchema = z.enum([
  'ACTIVE',
  'PAUSED',
  'DELETED',
  'ARCHIVED',
]);

/**
 * @description Status from Facebook that determines if the campaign/adset/ad is set to be paused/active
 * this is reused for all ad-related objects on fb's api
 */
export type AdObjectActiveStatus = z.TypeOf<typeof adObjectActiveStatusSchema>;

export const campaignEffectiveStatusSchema = z.enum([
  'ACTIVE',
  'PAUSED',
  'DELETED',
  'ARCHIVED',
  'IN_PROCESS',
  'WITH_ISSUES',
]);

/**
 * @description Campaign Status from Facebook that determines the delivery status, whether or not this campaign will serve ads
 */
export type EffectiveCampaignStatus = z.TypeOf<
  typeof campaignEffectiveStatusSchema
>;

export const adsetEffectiveStatusSchema = z.enum([
  'ACTIVE',
  'PAUSED',
  'DELETED',
  'ARCHIVED',
  'IN_PROCESS',
  'WITH_ISSUES',
  'CAMPAIGN_PAUSED',
]);

/**
 * @description Adset Status from Facebook that determines the delivery status, whether or not this adset is serving ads
 */
export type EffectiveAdsetStatus = z.TypeOf<typeof adsetEffectiveStatusSchema>;

export const adEffectiveStatusSchema = z.enum([
  'ACTIVE',
  'PAUSED',
  'DELETED',
  'ARCHIVED',
  'IN_PROCESS',
  'WITH_ISSUES',
  'CAMPAIGN_PAUSED',
  'PENDING_REVIEW',
  'DISAPPROVED',
  'PREAPPROVED',
  'PENDING_BILLING_INFO',
  'ADSET_PAUSED',
]);

/**
 * @description Ad Status from Facebook that determines the delivery status specifically for this ad
 */
export type EffectiveAdStatus = z.TypeOf<typeof adEffectiveStatusSchema>;

export type EffectiveStatus =
  | EffectiveCampaignStatus
  | EffectiveAdsetStatus
  | EffectiveAdStatus;
